// roster.ts — a thin row of chips showing who's in the room: name + instrument.

import { hueForUserVoice, PLINK_VOICE_LABELS, type PlinkVoiceId } from "../audio";

export interface RosterEntry {
  userId: string;
  voice: PlinkVoiceId;
  name: string;
  isYou: boolean;
}

export function renderRoster(root: HTMLElement, entries: RosterEntry[]): void {
  root.innerHTML = "";
  // local user first, then peers
  const ordered = [...entries].sort((a, b) => Number(b.isYou) - Number(a.isYou));
  for (const e of ordered) {
    const hue = hueForUserVoice(e.userId, e.voice);
    const chip = document.createElement("div");
    chip.className = "roster-chip" + (e.isYou ? " you" : "");

    const dot = document.createElement("span");
    dot.className = "roster-dot";
    dot.style.background = `hsl(${hue}, 85%, 62%)`;
    dot.style.boxShadow = `0 0 8px hsl(${hue}, 90%, 60%)`;

    const label = document.createElement("span");
    label.className = "roster-label";
    const who = e.name || (e.isYou ? "you" : "player");
    label.textContent = `${who}${e.isYou ? " (you)" : ""} · ${PLINK_VOICE_LABELS[e.voice]}`;

    chip.appendChild(dot);
    chip.appendChild(label);
    root.appendChild(chip);
  }
}
